export default __webpack_public_path__ + "static/media/Black-Render-Square-removebg-mobile.609b4bcb.png";